<template>
  <div class="like-theme-box" v-if="data">
    <span :class="'theme-tag' + tagClass(data)" v-if="data.themetype !== ''">{{data.themetype !== 'movie' ? 'VOD' : '영화'}}</span>
    <span class="theme-hd-box">
      <a @click="moveUrl(data)" :class="data.themetype ==='' ? 'remove-elements' : ''"><span class="theme-hd">{{editorPickTitle(data)}}</span></a>
      <span class="theme-heart">
        <btn-zzim-with-api :isOn="data.zzim" contentsType="theme" :contentsId="data.themeid" :index="(index - 1) * 2" :is-mypooq="true"/>
      </span>
    </span>
  </div>
</template>

<script>
import _ from 'lodash'
import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
export default {
  name: 'LikeThemeList',
  components: {
    BtnZzimWithApi
  },
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  methods: {
    moveUrl (data) {
      const url = _.get(data, 'url', '')
      if (url === '') {
        alert('이 에디터Pick은 현재 존재하지 않는 에디터Pick입니다.')
        return
      }
      this.$router.push(url.replace('https://www.wavve.com', ''))
    },
    editorPickTitle (data) {
      return _.get(data, ['title_list', '0', 'text'], '')
    },
    tagClass (data) {
      return data.themetype === 'movie' ? ' theme-tag-movie' : ' theme-tag-vod'
    }
  }
}
</script>
<style scoped>
  a:link, a:active, a:visited {
    text-decoration:none; color:#000000;
  }
</style>
